import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    groupLabel: (total: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for access requests group within the notifications panel */
            groupLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (total: number): string => __intl__.intl().formatMessage({ id: "AccessRequestsGroup.groupLabel?c=722akl2oftud", defaultMessage: "Access Requests ({total, number})" }, { total: total }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
